class Node {
    /**
     * @param value {NodeValue}
     * @param parent {Node}
     * @param children {Array.<Node>}
     */
    constructor (value, parent, children) {
        this.value = value;
        this.parent = parent;
        this.children = children;
    }
}

export default Node;
